import {
  createContext,
  Dispatch,
  RefObject,
  SetStateAction,
  useContext,
} from 'react';

import { AgGridReact } from 'ag-grid-react';

import { IncubatorResponse } from '@/services/lookups/types';

import {
  FertilizationDonorScheduleType,
  PulledSemenType,
  TechType,
} from './types';

const FertilizationContext = createContext<{
  poolSires: boolean;
  setPoolSires: Dispatch<SetStateAction<boolean>>;
  showTodaysFerts: boolean;
  setShowTodaysFerts: Dispatch<SetStateAction<boolean>>;
  fertPlateLotNo: string;
  setFertPlateLotNo: Dispatch<SetStateAction<string>>;
  fertMediaLotNo: Date | undefined;
  setFertMediaLotNo: Dispatch<SetStateAction<Date | undefined>>;
  mineralOilLot: string;
  setMineralOilLot: Dispatch<SetStateAction<string>>;
  serum: string;
  setSerum: Dispatch<SetStateAction<string>>;
  QCIsolate: string;
  setQCIsolate: Dispatch<SetStateAction<string>>;
  EHMMedia: Date | undefined;
  setEHMMedia: Dispatch<SetStateAction<Date | undefined>>;
  SOFMediaLotNo: Date | undefined;
  setSOFMediaLotNo: Dispatch<SetStateAction<Date | undefined>>;
  culturePlateLotNo: string;
  setCulturePlateLotNo: Dispatch<SetStateAction<string>>;
  cultureIncubatorNo: string | undefined;
  setCultureIncubatorNo: Dispatch<SetStateAction<string | undefined>>;
  procTech: TechType | null;
  setProcTech: Dispatch<SetStateAction<TechType | null>>;
  moveTech: TechType | null;
  setMoveTech: Dispatch<SetStateAction<TechType | null>>;
  fertTech: TechType | null;
  setFertTech: Dispatch<SetStateAction<TechType | null>>;
  incubators: IncubatorResponse[] | undefined;
  pulledSemenData: PulledSemenType[];
  fertilizationDonorScheduleData: FertilizationDonorScheduleType[];
  donorGridRef: RefObject<AgGridReact<FertilizationDonorScheduleType>>;
  semenGridRef: RefObject<AgGridReact<PulledSemenType>>;
  selectedSemenRows: PulledSemenType[];
  setSelectedSemenRows: Dispatch<SetStateAction<PulledSemenType[]>>;
  selectedDonorRows: FertilizationDonorScheduleType[];
  setSelectedDonorRows: Dispatch<
    SetStateAction<FertilizationDonorScheduleType[]>
  >;
  fertComments: number[];
  setFertComments: Dispatch<SetStateAction<number[]>>;
  handleRefresh: () => void;
  updateFilters: (e: boolean) => void;
  handleSelectionChanged: () => void;
  showReverseSort: boolean;
  setShowReverseSort: Dispatch<SetStateAction<boolean>>;
} | null>(null);

export function useFertilizationContext() {
  const context = useContext(FertilizationContext);
  if (!context) {
    throw new Error(
      'Fertilization.* component must be rendered as child of Fertilization component',
    );
  }

  return context;
}

export default FertilizationContext;
